<template>
  <div class="xcar pb-0 mb-0">
    <v-btn small class="ma-0" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h4 class="text-primary text-center mt-0 pt-0 mb-0">
      ASIGNACIONES DE LA CORPORACION
    </h4>

    <v-row dense class="ml-2">
      <v-col cols="12" sm="6" md="3">
        <v-menu
          v-model="menu2"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              label="Seleccione la fecha:"
              prepend-icon="mdi-calendar"
              readonly
              outlined
              dense
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date" @input="menu2 = false"></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field v-model.number="xcuota" label="Cuota:" type="number" dense outlined />
      </v-col>
      <v-col cols="12" sm="3" md="4">
        <v-switch
          v-model="only_cuota"
          :label="only_cuota ? 'Mostrar desde cuota seleccionada' : 'Mostrar solo cuota seleccionada'"
          :disabled="loading"
          dense
          hide-details
          title="Mostrar datos de la cuota seleccionada."
          class="mb-4"
        ></v-switch>
      </v-col>
      <v-col cols="2">
        <v-switch
          v-model="omit_filtro"
          label="Mostrar total"
          :disabled="loading"
          dense
          hide-details
          title="Omitir el filtro por convenio y mostrar todo."
          class="mb-4"
        ></v-switch>
      </v-col>
      <v-col cols="12" sm="2" md="3">
        <v-btn class="blue darken-2" dark tile :disabled="loading" @click="obtenerasignaciones()">Calcular</v-btn>
      </v-col>
    </v-row>
    <p class="text-center text-danger pa-0" v-if="msg">
      <b>{{ msg }}</b>
    </p>
    <v-progress-linear indeterminate v-if="loading" class="mt-2" />
    <div><AAsignacionTablaS ref="asignacionestablas" v-on:dataloaded="dataloaded" /></div>
  </div>
</template>

<script>
  import AAsignacionTablaS from '@/components/AAsignacionCorporacionV2.vue';

  export default {
    data() {
      return {
        gestiones: [2024,2023, 2022, 2021, 2020, 2019, 2018],
        meses: [
          { id: 1, text: 'Enero' },
          { id: 2, text: 'Febrero' },
          { id: 3, text: 'Marzo' },
          { id: 4, text: 'Abril' },
          { id: 5, text: 'Mayo' },
          { id: 6, text: 'Junio' },
          { id: 7, text: 'Julio' },
          { id: 8, text: 'Agosto' },
          { id: 9, text: 'Septiembre' },
          { id: 10, text: 'Octubre' },
          { id: 11, text: 'Noviembre' },
          { id: 12, text: 'Diciembre' },
        ],
        tiposasignacion: [
          { id: 1, text: 'Asignacion' },
          { id: 2, text: 'Inscritos' },
        ],
        loadinggestion: false,
        loadingmes: false,
        filtros: {
          gestion: null,
          mes: null,
          tipoasignacion: null,
        },
        buscar: '',
        datos: [],
        loading: false,
        msg: '',
        omit_filtro: false,

        date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
        menu2: false,
        xcuota: 1,
        only_cuota: true,
      };
    },
    watch: {
      '$store.state.CARGO.sede': function() {
        this.resetcache();
        this.obtenerasignaciones();
      },
      '$store.state.convenio': function() {
        if (this.$store.state.convenio) {
          this.obtenerasignaciones();
        }
      },
      date: function() {
        this.validarNoFechaFutura();
      },
    },
    components: { AAsignacionTablaS },
    methods: {
      dataloaded() {
        this.loading = false;
      },
      defaultdata() {
        let date = new Date();
        let anio = date.getFullYear();
        let mes = date.getMonth() + 1;
        this.filtros.tipoasignacion = this.tiposasignacion[0];
        this.filtros.gestion = '' + anio;
        this.filtros.mes = this.meses.find((x) => x.id == mes);
      },
      resetcache() {
        this.$refs.asignacionestablas.resetcache();
      },
      validarNoFechaFutura() {
        let date = new Date(Date.now() - new Date().getTimezoneOffset() * 60000);
        date.setHours(23);
        date.setMinutes(59);

        let date2 = new Date(this.date);
        date2.setHours(date2.getHours() + 4);

        let mayor = date2.getTime() > date.getTime();
        if (mayor) {
          let vue = this;
          let hoy = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
          const [year, month, day] = hoy.split('-');
          let txt = `${year}-${month}-${day}`;
          this.$root.$notify.show(`Fechas futuras no estan permitidas.`, { color: 'red' });
          setTimeout(() => {
            vue.date = txt;
          }, 500);
        }
      },
      obtenerasignaciones() {
        if (!this.filtros.gestion) return;
        if (!this.filtros.mes) return;
        if (this.loading) return;
        this.loading = true;
        let convenio = 0;
        if (this.$store.state.convenio && !this.omit_filtro) convenio = this.$store.state.convenio.id;
        this.$refs.asignacionestablas.obtenerasignaciones(convenio, this.xcuota, this.date, this.only_cuota);
      },
    },
    mounted() {
      this.defaultdata();
      //this.obtenerasignaciones();
    },
  };
</script>
